import { useRef, useCallback } from 'react';
function useForwardedRef(forwardedRef) {
  const localRef = useRef(null);
  const bindRef = useCallback(node => {
    localRef.current = node;
    if (!forwardedRef) {
      return;
    }
    if (typeof forwardedRef === 'function') {
      forwardedRef(localRef.current);
    } else {
      // eslint-disable-next-line no-param-reassign
      forwardedRef.current = node;
    }
  }, [forwardedRef]);
  return [bindRef, localRef];
}
export default useForwardedRef;